module.exports = __webpack_public_path__ + "img/frame (250).aad299f0.jpg";